// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"24":"f48cddf9c28711c0","197":"b5bd4c889b5ae374"}[chunkId] + ".js";
};